/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimeOffs} from '../api'

 export const useQueryGetTimeOffs = createReactQueryHook('getTimeOffs', getTimeOffs)
